import ApplicationSerializer from 'lumen/serializers/application';

export default class ParityStrategyHotelSerializer extends ApplicationSerializer {
  attrs = {
    subscription: 'value_id',
  };
}
